module.exports = __webpack_public_path__ + "static/img/Store-17.6337279a.png";